module.exports = __webpack_public_path__ + "img/blue-shoe.24a1af58.png";